import * as React from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { bindActionCreators } from 'redux';
import { flow, map, isEmpty } from 'lodash';
import {Field, reduxForm} from 'redux-form';
import { IAuthState } from '../../../../../../services/auth/models';
import { Col, FormGroup, ControlLabel, Form, Button } from 'react-bootstrap';
import FieldFormControl from '../../../../../../components/FieldFormControl';
import {isRequired, isEmail} from '../../../../../../util/validators';
import {Link} from 'react-router-dom';
import {translatePasswordError} from '../../../../../../util/helpers';

interface IResetPasswordFormProps {
  actions: {
    push(route: string);
  };
  auth: IAuthState;
  buttonText: string;
  handleSubmit: () => void;
}

class ResetPasswordForm extends React.Component<IResetPasswordFormProps> {
  public render() {
    const { handleSubmit, buttonText, auth } = this.props;

    return (
      <Form horizontal={true} onSubmit={handleSubmit} autoComplete="off">
        <FormGroup controlId="name">
          <Col componentClass={ControlLabel} sm={3}>
            Your email address
          </Col>
          <Col sm={5}>
            <Field
              name="email"
              type="email"
              component={FieldFormControl}
              validate={[isRequired, isEmail]}
              placeholder="email@domain.com"
            />
          </Col>
        </FormGroup>
        <FormGroup controlId="name">
          <Col componentClass={ControlLabel} sm={3}>
            Your password
          </Col>
          <Col sm={5}>
            <Field
              name="password"
              type="password"
              validate={[isRequired]}
              component={FieldFormControl}
              placeholder="Password"
            />
          </Col>
        </FormGroup>
        <FormGroup controlId="name">
          <Col componentClass={ControlLabel} sm={3}>
            Confirm your password
          </Col>
          <Col sm={5}>
            <Field
              type="password"
              name="passwordConfirmation"
              validate={[isRequired]}
              component={FieldFormControl}
              placeholder="Confirm Password"
            />
          </Col>
        </FormGroup>
        <div className="alert alert-warning">
          Your password must contain at least 10 characters, including one lowercase, one uppercase,
          a special character and a number
        </div>
        {auth && auth.error && ! isEmpty(auth.error.reset) && (
          <div className="alert alert-danger" style={{marginTop: '10px'}}>
            {map(auth.error.reset, (error, key) => {
              return <p key={key}>{error.detail}</p>;
            })}
          </div>
        )}
        <div className="btn-bar section">
          <Button
            type="submit"
            className="btn btn-secondary pull-right"
          >
            {buttonText ? buttonText : 'Reset your password'}
          </Button>
        </div>
      </Form>
    );
  }
}

const validate = (values) => {
  const errors = {};
  if (values.passwordConfirmation !== values.password) {
    errors.passwordConfirmation = 'The password does not match the one previously entered, please enter it again.';
  }
  return errors;
};

export default flow([
  reduxForm({
    form: 'reset_password',
    destroyOnUnmount: false,
    validate,
    forceUnregisterOnUnmount: true,
  }),
  connect(
    (dispatch) => ({
      actions: {
        push: bindActionCreators(push, dispatch),
      },
    }),
  ),
])(ResetPasswordForm);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/scenes/CustomerArea/scenes/ResetPassword/components/ResetPasswordForm/index.tsx